<template>
  <div>
    <b-card class="standardpage">
      <b-card-header>
        <b-row>
          <b-col cols="12" sm="6" class="text-right text-sm-left pt-1">
            <i :class="options.icon" class="mr-1"></i>
            <span>{{ options.title }}</span>
          </b-col>
          <b-col cols="12" sm="6" class="mt-2 mt-sm-0">
            <div class="card-header-actions">
              <div style="display: flex; justify-content: space-between">
                <b-form-group size="sm" class="mb-0">
                  <b-input-group>
                    <b-form-input
                      size="sm"
                      v-model="find"
                      placeholder="Find"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button
                        size="sm"
                        style="width: auto; padding: 0.25rem 0.6rem"
                        variant="outline-primary"
                        :disabled="!find"
                        @click="find = ''"
                      >
                        <i v-if="find" class="fa fa-remove"></i>
                        <i v-if="!find" class="fa fa-search"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>

                <b-button
                  id="suppliertype-refresh"
                  size="sm"
                  squared
                  variant="outline-primary"
                  class="card-header-action ml-1"
                  @click="refresh()"
                >
                  <i class="fa fa-refresh"></i>
                </b-button>
              </div>
            </div>
          </b-col>
        </b-row>

        <b-tooltip target="suppliertype-add" triggers="hover"
          >Click to add supplier type</b-tooltip
        >
        <b-tooltip target="suppliertype-refresh" triggers="hover"
          >Click to refresh table</b-tooltip
        >
      </b-card-header>
      <!-- <b-card-body v-if="addRow" class="py-0">
        <b-row class="w-100pct pl-1">
          <BLSupplierTypeEdit
            v-if="addRow"
            :search="search"
            @discard="discard()"
            @refresh="refresh()"
          />
        </b-row>
      </b-card-body> -->

      <div v-if="!addRow" class="availtable datatable">
        <b-card class="w-100pct">
          <b-card-body class="py-0">
            <b-row>
              <b-col cols="12" sm="12" md="12" xl="12">
                <b-form-textarea
                  id="data"
                  v-model="SQLRaw"
                  placeholder="SQL Input"
                  rows="6"
                  max-rows="8"
                  class="smalltextarea"
                ></b-form-textarea>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" sm="12" md="12" xl="12">
                <b-button
                  class="mt-2 mb-2"
                  size="sm"
                  squared
                  variant="primary"
                  @click="edit()"
                >
                  <i class="fa fa-magic"></i>
                </b-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" sm="12" md="12" xl="12">
                <b-form-textarea
                  id="data"
                  v-model="SQLNew"
                  placeholder="SQL Result"
                  rows="6"
                  max-rows="8"
                  class="smalltextarea"
                  readonly
                ></b-form-textarea>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
        <!-- <div class="px-3">
          <b-overlay
            :show="options.overlay_show"
            opacity=".9"
            v-click-outside="outside"
          >
            <div>
              <b-table
                :dark="$store.state.darkMode"
                ref="btable"
                sticky-header="350px"
                striped
                hover
                small
                caption-bottom
                show-empty
                :busy="busy"
                :items="items"
                :fields="options.fields"
                :filter="find"
                @row-clicked="rowClicked"
              >
                <template v-slot:table-busy>
                  <div class="text-center my-2">
                    <b-spinner
                      variant="primary"
                      class="align-middle mr-2"
                    ></b-spinner>
                    <strong class="text-primary">Loading...</strong>
                  </div>
                </template>
                <template v-slot:cell(icon)>
                  <i :class="options.icon" class="text-primary"></i>
                </template>

                <template v-slot:cell()="row">
                  <div
                    v-if="
                      options.badges &&
                      options.badges.find((obj) => obj.key == row.field.key)
                    "
                  >
                    <span
                      v-html="
                        $helpers.badgeField(
                          row.item,
                          options.badges.find(
                            (obj) => obj.key == row.field.key
                          ),
                          options
                        )
                      "
                    ></span>
                  </div>
                  <div v-else>{{ row.value }}</div>
                </template>
                <template v-if="options.actions" v-slot:cell(actions)="row">
                  <div id="actions-container" v-if="options.actions_as_elipses">
                    <b-button
                      variant="link"
                      size="sm"
                      title="Actions"
                      :id="'popover-target-' + row.item.id"
                      @click="$root.$emit('bv::hide::popover')"
                    >
                      <i class="fa fa-ellipsis-h text-primary"></i>
                    </b-button>
                    <b-popover
                      container="actions-container"
                      triggers="click blur"
                      placement="leftbottom"
                      :target="'popover-target-' + row.item.id"
                    >
                      <div>
                        <b-nav vertical>
                          <b-nav-item
                            :title="action.label"
                            v-for="action in $helpers.actionsValid(
                              row.item,
                              options
                            )"
                            :key="action.key"
                            @click.stop="table_action(action.key, row)"
                          >
                            <b-row class="px-2">
                              <b-col class="px-0">
                                <span class="text-normal">{{
                                  action.label
                                }}</span>
                              </b-col>
                              <b-col cols="1">
                                <i
                                  :class="action.icon"
                                  class="text-primary"
                                ></i>
                              </b-col>
                            </b-row>
                          </b-nav-item>
                        </b-nav>
                      </div>
                    </b-popover>
                  </div>
                  <div v-else>
                    <b-button
                      variant="link"
                      size="sm"
                      v-for="action in $helpers.actionsValid(row.item, options)"
                      :key="action.key"
                      @click.stop="table_action(action.key, row)"
                      :title="action.label"
                    >
                      <i :class="action.icon" class="text-primary"></i>
                    </b-button>
                  </div>
                </template>

                <template v-slot:row-details="row">
                  <b-card>
                    <component
                      :is="options.component.name"
                      :search="search"
                      @discard="discard(row)"
                      @refresh="refresh()"
                    ></component>
                  </b-card>
                </template>
              </b-table>
            </div>

            <template #overlay>
              <div class="text-center">
                <p id="cancel-label">{{ options.overlay.message }}</p>
                <hr />
                <b-row>
                  <b-col>
                    <b-button
                      v-for="(button, index) in options.overlay.buttons"
                      :key="index"
                      :style="button.style ? button.style : 'width: 80px'"
                      :class="
                        button.class
                          ? button.class
                          : button.dispatch
                          ? null
                          : 'ml-2'
                      "
                      :variant="
                        button.variant
                          ? button.variant
                          : button.dispatch
                          ? 'outline-primary'
                          : 'outline-secondary'
                      "
                      :size="button.size ? button.size : 'sm'"
                      :squared="button.squared ? button.squared : true"
                      @click="
                        button.dispatch
                          ? dispatcher(button.dispatch)
                          : (options.overlay_show = false)
                      "
                      >{{ button.label }}</b-button
                    >
                  </b-col>
                </b-row>
              </div>
            </template>
          </b-overlay>
        </div> -->
      </div>

      <!-- <b-row class="excelsheetbuttons px-3">
        <b-col>
          <div v-if="busy">
            <i class="fa fa-spinner fa-spin text-primary"></i>
            <span class="small text-primary ml-1">Updating ...</span>
          </div>
          <span v-if="!busy" class="small text-primary"
            >Found {{ items.length }} rows</span
          >
        </b-col>

        <b-col class="text-right">
          <b-link
            id="flights-excel"
            class="mt-1 excel"
            @click="$helpers.outputExcel({ items, fields: options.fields })"
            title="Send to excel"
          >
            <i class="fa fa-file-excel-o" aria-hidden="true"></i>
          </b-link>
          <b-tooltip target="flights-excel" triggers="hover"
            >Grid to excel</b-tooltip
          >
        </b-col>
      </b-row> -->
    </b-card>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";

export default {
  name: "EditSQL",
  data() {
    return {
      addRow: false,
      busy: false,
      find: "",
      SQLRaw: null,
      SQLNew: null,
      items: [],
      search: {
        selected: null,
      },
      options: {
        title: "Query Editor - Prototype",
        icon: "fa fa-quora",
        debounce: 500,
        toolbars: [
          {
            key: "refresh",
            class: "mr-1",
            type: "button",
            icon: "fa fa-refresh",
            "busy-icon": "fa fa-refresh fa-spin",
            label: "Refresh",
          },
          { key: "is_separator", type: "separator" },
        ],
        fields: [
          {
            key: "icon",
            label: "",
            class: "text-center w-30px",
          },
          {
            key: "id",
            label: "Code",
            sortable: true,
          },
          {
            key: "name",
            label: "Description",
            sortable: true,
          },
          {
            key: "reports",
            label: "Reports",
            sortable: true,
          },
          {
            key: "order",
            label: "Order",
            sortable: true,
            class: "text-left",
          },
          {
            key: "ownevent",
            label: "Own Event",
            sortable: true,
          },
          {
            key: "amexcode",
            label: "AMEX Code",
            sortable: true,
          },
          {
            key: "salesnl",
            label: "Sales N/L",
            sortable: true,
          },
          {
            key: "costsnl",
            label: "Costs N/L",
            sortable: true,
          },
          {
            key: "actions",
            label: "Actions",
            class: "actions w-100px",
          },
        ],
        badges: [
          {
            key: "vatable",
            type: "badge",
            Yes: "success",
            No: "danger",
            formatter: (value, key, item) => {
              if (value == false) {
                return "No";
              } else if (value == true) {
                return "Yes";
              } else {
                return "";
              }
            },
          },
          {
            key: "invoicetype",
            type: "badge",
            P: "info",
            N: "danger",
            E: "info",
          },
        ],
        actions: [
          {
            key: "edit",
            label: "Edit",
            icon: "fa fa-pencil",
            single: true,
            multiple: false,
            component: {
              name: "Setup_SupplierTypeEdit",
            },
          },
        ],
        actions_as_elipses: false,
        modal: {},
        component: {},
        overlay_show: false,
        overlay: {},
      },
    };
  },
  mounted() {
    // // ONLY ADD ACTIONS IF THE ARRAY EXISTS AND NOT ALREADY ADDED AT CONTROLLED WIDTH
    if (this.options.actions) {
      if (this.options.fields.some((e) => e.key === "actions")) {
      } else {
        this.options.fields.push({
          key: "actions",
          label: "",
          class: "actions w-140px",
        });
      }
    }
    if (
      this.user.rolename == "admin"
    ) {
      this.options.actions.push({
        key: "delete",
        label: "Delete",
        icon: "fa fa-trash text-danger",
        single: true,
        multiple: true,
        overlay: {
          message: "Are you sure you want to delete row %id% ?",
          buttons: [
            {
              label: "Yes",
              variant: "danger",
              dispatch: "delete",
            },
            {
              label: "No",
              class: "ml-2",
            },
          ],
        },
      });
    }
    this.$helpers.resizableColumns();

    // this.loadDDL();
    // this.load();
  },
  computed: {
    ...mapGetters(["user", "window"]),
  },
  methods: {
    edit() {
      let result = this.SQLRaw;

      var s = "pass[1][2011-08-21][total_passes]";
      var matches = [];

      var pattern = /\[(.*?)\]/g;
      var match;
      while ((match = pattern.exec(result)) != null) {
        let token = match[1]
        if (token.includes("saracs")) {
          if (!matches.includes(token)) {
            matches.push(token);
          }
        }
      }
      result = result.split("["+matches[0]+"].").join("");

      result = result.split("#").join("'");
      result = result.split('"').join("'");
      result = result.split("[").join('"');
      result = result.split("]").join('"');
      result = result.split("*'").join("%'");
      result = result.split("'*").join("'%");
      result = result.split('"saracs_').join('"');

      this.SQLNew = "SET search_path TO saracs,public;\n" + result;
    },
    async table_action(key, row) {
      this.$root.$emit("bv::hide::popover");
      console.log("you have clicked: ", key, row);

      this.search.selected = row.item;
      for (var i = 0; i < this.options.actions.length; i++) {
        if (this.options.actions[i].key == key) {
          if (this.options.actions[i].hasOwnProperty("modal")) {
            // this.selected = !Array.isArray(sender) ? [sender.item] : sender;
            // this.modal = this.actions[i].modal;
            // this.modalActive = true;
            console.log(this.options.modal);
            return;
          }
          if (this.options.actions[i].hasOwnProperty("component")) {
            this.options.component = this.options.actions[i].component;
            // ONLY ALLOW ONE EXPANSION
            for (var k = 0; k < this.items.length; k++) {
              this.$set(this.items[k], "_showDetails", false);
            }
            row.toggleDetails();
            return;
          }
          if (this.options.actions[i].hasOwnProperty("overlay")) {
            if (this.options.actions[i].overlay.message) {
              let message = this.options.actions[i].overlay.message;
              for (var prop in row.item) {
                if (Object.prototype.hasOwnProperty.call(row.item, prop)) {
                  message = message
                    .split("%" + prop + "%")
                    .join(row.item[prop]);
                }
              }
              this.options.overlay.message = message;
            }
            if (this.options.actions[i].overlay.buttons) {
              this.options.overlay.buttons = this.options.actions[
                i
              ].overlay.buttons;
            }
            this.options.overlay_show = !this.options.overlay_show;
            return;
          }
        }
      }
    },
    async rowClicked(item) {
      console.log("row clicked", item);

      // DEFAULT COMPONENT IS THE FIRST ONE
      if (this.options.actions.length > 0) {
        if (this.options.actions[0].component) {
          this.options.component = this.options.actions[0].component;
        }
      }

      this.search.selected = item;
      let lo = -1;
      // CLOSE ALL
      for (var k = 0; k < this.items.length; k++) {
        if (this.items[k]._showDetails) {
          lo = k;
        }
        this.$set(this.items[k], "_showDetails", false);
      }
      item._showDetails = lo == item.ID ? false : true;
    },
    async discard(row) {
      console.log("discard", row);
      if (row) {
        row.item._showDetails = false;
      }
      this.addRow = false;
    },
    async outside(e) {
      console.log("clicked outside!");
      this.options.overlay_show = false;
    },
    async dispatcher(action) {
      console.log("dispatcher action", action);
      switch (action) {
        case "delete":
          await this.remove();
      }
      this.options.overlay_show = false;
    },
  },
};
</script>

<style>
</style>